import axios from 'axios';
import url from '@/url';

const base = process.env.VUE_APP_SERVICE_URL + url.tenant_agora_configs;

const authHeaders = () => ({
  headers: {
    'X-Authorization': localStorage.getItem('token'),
  },
});

const unwrap = (response) => {
  const result = response?.data?.result;
  if (result && (result.status === 200 || result.status === 201)) {
    return result.data;
  }
  return null;
};

/**
 * Fetch the Agora + S3 configuration for a tenant.
 * Backend returns each field as { set, value, last4 } where `value` is null for secrets.
 */
export const getTenantAgoraConfig = async (tenantId) => {
  const response = await axios.get(`${base}${tenantId}/agora-config`, authHeaders());
  const data = unwrap(response);
  // Backend wraps response as { data: { CODE: {...} } } — unwrap one level.
  return data?.data ?? data ?? {};
};

/**
 * Upsert Agora + S3 configuration for a tenant.
 * Only send the fields the user changed. Sending an empty string clears the value
 * (the row is deleted server-side so the env fallback takes over).
 */
export const upsertTenantAgoraConfig = async (tenantId, payload) => {
  const response = await axios.put(
    `${base}${tenantId}/agora-config`,
    payload,
    authHeaders(),
  );
  const data = unwrap(response);
  return data?.data ?? data ?? {};
};
